import { DiscordIcon, Facebook01Icon } from '@axieinfinity/dango-icons'
import { GitbookIcon } from '@axieinfinity/konan'
import { Fragment } from 'react'

import { useCaptureEvent } from '#/hooks'

import { FAQ } from '../faq/faq'
import { Judges } from '../judges/judges'
import { Partner } from '../partner/partner'
import { Prize } from '../prize/prize'
import { Timeline } from '../timeline/timeline'
import s from './overview.module.scss'

export const Overview = () => {
  const captureEvent = useCaptureEvent()

  return (
    <Fragment>
      <div className={s.section}>
        <div className={s.theme}>
          <div className={s.badge}>This year&apos;s theme</div>
          <div className={s.name}>Stronger, Faster, Better</div>
          <img src="/assets/axie-game-jam/puffy-05.png" />
          <div className={s.video}>
            <iframe
              src="https://www.youtube.com/embed/nCFi54tEMuw"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
        <div className={s.info}>
          <h3 className={s.heading}>What is Axie Game Jam?</h3>
          <p className={s.description}>
            Axie Game Jam is a 2-week marathon for indie game developers to create
            Axie games based on a theme. Join us to showcase your skills, learn
            from the Axie Infinity community, and unleash your creativity with the
            Axie Generator Tool Kit!
          </p>
          <div className={s.keyNote}>
            <div className={s.noteLabel}>Key info</div>
            <div className={s.noteItem}>
              Anyone, of any age, from anywhere can join the jam. You can work
              alone or in teams.
            </div>
            <div className={s.noteItem}>
              The theme of this jam is set at the start of submission to follow
              and make your game fit the theme.
            </div>
            <div className={s.noteItem}>
              The game should be developed during the jam and use{' '}
              <a
                href="https://github.com/axieinfinity/awesome-axie-gtk"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  captureEvent('Click Axie Generator Tool Kit (Overview)')}
              >
                Axie Generator Tool Kit
              </a>{' '}
              as the main assets.
            </div>
            <div className={s.noteItem}>
              Games will be evaluated based on Game Design, Enjoyment, Graphics,
              and Innovation by the public and judges. The judges will play the
              top games and select the winners.
            </div>
            <p className={s.description}>
              Join our{' '}
              <a
                href="https://discord.gg/8WstpS7VJs"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => captureEvent('Click AGJ Discord (Overview)')}
              >
                Discord
              </a>{' '}
              for more info!
            </p>
          </div>
        </div>
        <div className={s.image}>
          <img src="/assets/axie-game-jam/introduction.png" />

          <div className={s.socials}>
            <p>Follow our social channels to keep updated!</p>
            <a
              className={s.button}
              href="https://discord.gg/8WstpS7VJs"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => captureEvent('Click AGJ Discord (Icon)')}
            >
              <div className={s.icon}>
                <DiscordIcon />
              </div>
              Discord
            </a>
            <a
              className={s.button}
              href="https://www.facebook.com/axiegamejam"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => captureEvent('Click AGJ Facebook (Icon)')}
            >
              <div className={s.icon}>
                <Facebook01Icon />
              </div>
              Facebook
            </a>
            <a
              className={s.button}
              href="https://axie-game-jam.gitbook.io/axie-game-jam/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => captureEvent('Click AGJ Gitbook (Icon)')}
            >
              <div className={s.icon}>
                <GitbookIcon />
              </div>
              Gitbook
            </a>
          </div>
        </div>
      </div>
      <div className={s.container}>
        <div className={s.details}>
          <Prize />
          <Timeline />
          <Judges />
          <div className={s.doodles} />
          <FAQ />
          <Partner />
        </div>
      </div>
    </Fragment>
  )
}
